import React from "react";
import Maincontent from "./pages/Maincontent";

const SystemSetting = () => {
  return (
    <>
      <div className="systemSetting">
        <Maincontent />
      </div>
    </>
  );
};

export default SystemSetting;
